export const defaultValues = {
  fromName: "Host Name",
  fromCompanyName: "Company Name",
  senderImageUrl:
    "http://cdn.mcauto-images-production.sendgrid.net/e06030a11d676536/adc43503-af97-4868-abdf-5042427262c8/381x84.png",
  subject: "Sample subject",
  eventName: "Sample Event",
  eventUrl: "https://live.remo.co/e/test-event",
  eventDateTime: "2nd December 2024 - 10:00pm HKT",
  userName: "User Name",
  days: "3",
  imageUrl:
    "https://images.unsplash.com/photo-1539146395724-de109483bdd2?h=490&w=780",
  videoUrl: "https://youtu.be/tbpHcsr09Pc",
  videoThumbnailUrl:
    "http://cdn.mcauto-images-production.sendgrid.net/e06030a11d676536/249ee1b1-c550-47c2-89ac-a6a50926a1c2/640x480.jpg",
  geartestUrl: "https://live.remo.co/geartest",
  guestGuideUrl:
    "https://9297632.fs1.hubspotusercontent-na1.net/hubfs/9297632/Event%20Guides/Remo%20Checklist%20for%20Guests%20042024.pdf",
  googleCalendarUrl:
    "https://calendar.google.com/calendar/render?action=TEMPLATE&text=Sample+Event",
  yahooCalendarUrl: "https://calendar.yahoo.com/?v=60&title=Sample+Event",
  outlookCalendarUrl: "https://outlook.live.com/calendar/0/action/compose",
  icalCalendarUrl: "#",
  eventCTAButtonText: "Accept My Invitation",
  buttonText: "View Event",
  minsButtonText: "Join Event",
  inviteTextBlock1:
    "Here's your private invitation to join Sample Event! <br/><br/> I'm hosting this special event on an amazing, interactive online platform: Events.com Virtual (formerly Remo). <br/><br/> To get all the important details, click the button below.",
  inviteTextBlock2:
    "Ready for a game-changing experience? Watch the video below to see what makes our Remo events a must-attend!",
  regTextBlock1: "You're in! You have successfully registered for the event:",
  regTextBlock2:
    "When it's time to join the event, you can access it by clicking here:",
  regTextBlock3: "",
  regTextBlock4:
    "Unveil the magic, the excitement, the indescribable! Watch the video below to see what makes our events a must-attend!",
  daysTextBlock1:
    "When it's time to join the event, you can access it by clicking here:",
  daysTextBlock2:
    "Prepare for a revelation that will shatter your reality! This 1-minute video is your gateway to an event experience that defies imagination.",
  daysTextBlock3: "",
  minsTextBlock1: "You can access the event by clicking here:",
  minsTextBlock2:
    "Prepare for a revelation that will shatter your reality! This 1-minute video is your gateway to an event experience that defies imagination.",
  minsTextBlock3: "",
};
